import { ApmService } from '@elastic/apm-rum-angular';
import { environment } from './environments/environment';

export function initApm(apmService: ApmService) {
  if (!environment.APM.ACTIVE) {
    // Không init APM ở local/dev
    return () => {};
  }
  return () => {
    apmService.init({
      serviceName: environment.APM.SERVICE_NAME,
      serverUrl: environment.APM.SERVER_URL,
      serviceVersion: '1.0.0',
      environment: 'production',
      distributedTracingOrigins: [environment.APP_BASE_URL],
    });
  };
}
